import * as React from 'react';

import { MainTitleContainer } from '../../containers/MainTitle';
import { FlatInfo } from './FlatInfo';
import { JKInfo } from './JKInfo';
import { SuburbanInfo } from './SuburbanInfo';
import { CommercialInfo } from './CommercialInfo';
import { BargainTermsInfo } from './BargainTermsInfo';
import { IFavoriteEntity } from '../../types/results';

import * as styles from './FavoriteInfo.css';

export interface IFavoriteInfoProps {
  favoriteEntity: IFavoriteEntity;
}

export function FavoriteInfo({ favoriteEntity }: IFavoriteInfoProps) {
  const { fullUrl, title, flatInfo, suburbanInfo, jkInfo, commercialInfo, bargainTerms, entityId } = favoriteEntity;

  if (commercialInfo) {
    return (
      <div className={styles['base_info']}>
        <MainTitleContainer entityId={entityId} title={title} fullUrl={fullUrl} />
        <CommercialInfo commercialInfo={commercialInfo} />
      </div>
    );
  }

  return (
    <>
      <div className={styles['base_info']}>
        <MainTitleContainer entityId={entityId} title={title} fullUrl={fullUrl} />
        {flatInfo && <FlatInfo flatInfo={flatInfo} />}
        {jkInfo && <JKInfo jkInfo={jkInfo} />}
        {suburbanInfo && <SuburbanInfo suburbanInfo={suburbanInfo} />}
      </div>
      <div className={styles['price_info']}>
        {bargainTerms && <BargainTermsInfo bargainTerms={bargainTerms} isNewbuilding={Boolean(jkInfo)} />}
      </div>
    </>
  );
}
